<aura-edit-wrapper
  title="Alertes & Notifications de mandats"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-notifications-form
      [settings]="currentSettings()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-notifications-display [settings]="currentSettings()" />
  }
</aura-edit-wrapper>
